import { DownloadTradesApi } from "@/features/accounts/shared/services/download-trades-api";
import { DownloadTradesPostRequestModel } from "@/features/accounts/shared/services/download-trades-model";

/// Excel出力処理
export class DownloadTradesService {
  private downloadTradesApi = new DownloadTradesApi();

  /**
   * Excel出力API実行
   */
  public async downloadTrades(param: DownloadTradesPostRequestModel) {
    return await this.downloadTradesApi.downloadTrades(param);
  }

  /**
   * グループ単位Excel作成Job開始API実行
   */
  public async startDownloadExcelJob(param: DownloadTradesPostRequestModel) {
    return await this.downloadTradesApi.startDownloadExcelJob(param);
  }

  /**
   * グループ単位Excel作成Job状態確認API実行
   */
  public async getDownloadExcelJobStatus(downloadJobId: string) {
    return await this.downloadTradesApi.getDownloadExcelJobStatus(downloadJobId);
  }

  /**
   * グループ単位Excel成果物ダウンロードAPI実行
   */
  public async downloadExcelJobFile(downloadJobId: string) {
    return await this.downloadTradesApi.downloadExcelJobFile(downloadJobId);
  }
}

